/* eslint-disable react/destructuring-assignment */
import { DataGridPro, DataGridProProps } from "@mui/x-data-grid-pro";
import { FC } from "react";
import { StyledLinearProgress } from "../atoms/StyledLinearProgress";

const ROW_HEIGHT = 42;
const PAGE_SIZE_OPTIONS = [50];

const StyledDataGrid: FC<DataGridProProps> = (props) => (
  <DataGridPro
    rowHeight={props?.rowHeight || ROW_HEIGHT}
    columnHeaderHeight={ROW_HEIGHT}
    pageSizeOptions={PAGE_SIZE_OPTIONS}
    slots={{
      loadingOverlay: StyledLinearProgress,
    }}
    {...props}
  />
);

export { StyledDataGrid };
